import React, { useState, useEffect } from 'react';
import '../../assets/style/eegisterProvider.css';
import TextField from '@mui/material/TextField';
import { Button } from '@mui/material';
import OTPInput, { ResendOTP } from 'otp-input-react';
import { json, useNavigation } from 'react-router-dom';
import Web3 from 'web3';
import Api from '../../utils/Api';
import { toast } from 'react-toastify';
import { checkMetaMaskAvailability, checkHTTPS, getWalletConnectionError, isWalletConnected, getCurrentAccount } from '../../utils/walletUtils';
import components from '../../components';
import { useNavigate } from 'react-router';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

const RegisterFundSubscriber = () => {
  let Navigater = useNavigate();
  const [RegisterFundSubscriber, setRegisterFundSubscriber] = useState({
    firstName: '',
    Lastname: '',
    email: '',
    ConfirmPassword: '',
    Password: '',
  });
  const [Validation, setValidation] = useState({
    firstName: '',
    Lastname: '',
    email: '',
    ConfirmPassword: '',
    Password: '',
    WalletAddress: '',
  });
  const [WalletAddress, setWalletAddress] = useState('');
  const [loaderState, setloaderState] = useState();
  const [isconnected, setisconnected] = useState(false);

  // Check wallet connection status on page load
  useEffect(() => {
    const checkWalletStatus = async () => {
      try {
        if (!window.ethereum) {
          setisconnected(false);
          return;
        }

        // Check if MetaMask is available and unlocked
        const accounts = await window.ethereum.request({ method: 'eth_accounts' });
        
        if (accounts && accounts.length > 0) {
          // Check if wallet is truly unlocked by testing a simple call
          try {
            await window.ethereum.request({
              method: 'eth_getBalance',
              params: [accounts[0], 'latest']
            });
            // If successful, wallet is connected and unlocked
            setWalletAddress(accounts[0]);
            setisconnected(true);
            console.log('Wallet is connected and unlocked:', accounts[0]);
          } catch (balanceError) {
            // Wallet is locked
            console.log('MetaMask is locked:', balanceError.message);
            setisconnected(false);
            setWalletAddress('');
          }
        } else {
          // No accounts available
          setisconnected(false);
          setWalletAddress('');
        }
      } catch (error) {
        console.log('Error checking wallet status:', error);
        setisconnected(false);
        setWalletAddress('');
      }
    };

    checkWalletStatus();
  }, []);

  const handleChange = (event) => {
    setRegisterFundSubscriber({
      ...RegisterFundSubscriber,
      [event.target.name]: event.target.value,
    });
  };
  const connectWallet = async () => {
    try {
      setloaderState(true);

      // Check MetaMask availability
      const metaMaskCheck = checkMetaMaskAvailability();
      if (!metaMaskCheck.available) {
        toast.error(metaMaskCheck.error);
        setloaderState(false);
        return;
      }

      // Check HTTPS requirement
      const httpsCheck = checkHTTPS();
      if (!httpsCheck.isHTTPS) {
        toast.error(httpsCheck.error);
        setloaderState(false);
        return;
      }

      // If already connected, disconnect
      if (isconnected) {
        try {
          await window.ethereum.request({
            method: 'wallet_revokePermissions',
            params: [{ eth_accounts: {} }]
          });
          setisconnected(false);
          setWalletAddress('');
          toast.success('Wallet disconnected successfully');
          return;
        } catch (disconnectError) {
          console.log('Disconnect error:', disconnectError);
          // Still disconnect locally even if revoke fails
          setisconnected(false);
          setWalletAddress('');
          toast.success('Wallet disconnected');
          return;
        }
      }

      // Always request wallet connection to ensure MetaMask opens
      const accounts = await window.ethereum.request({
        method: 'eth_requestAccounts',
      });
      
      setloaderState(false);
      
      if (!accounts || accounts.length === 0) {
        toast.error('Please unlock your MetaMask wallet and try again');
        return;
      }
      
      setWalletAddress(accounts[0]);
      setisconnected(true);
      toast.success('You have connected with MetaMask successfully.');
      
      console.log('connectWallet accounts', accounts);
    } catch (error) {
      console.log('connectWallet error', error);
      setloaderState(false);
      
      const errorMessage = getWalletConnectionError(error);
      toast.error(errorMessage);
    }
  };
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setshowConfirmPassword] = useState(false);

  const onSubmit = async () => {
    let error = {};

    if (!RegisterFundSubscriber.firstName) {
      // Display an error message or handle validation failure as needed
      error.firstName = 'First Name is required';
      // toast.error("All fields are required");
    }
    if (!RegisterFundSubscriber.Lastname) {
      // Display an error message or handle validation failure as needed
      error.Lastname = 'Last Name is required';
      // toast.error("All fields are required");
    }
    if (!RegisterFundSubscriber.email) {
      // Display an error message or handle validation failure as needed
      error.email = 'Email is required';
      // toast.error("All fields are required");
    }
    if (!RegisterFundSubscriber.Password) {
      // Display an error message or handle validation failure as needed
      error.Password = 'Password is required';
      // toast.error("All fields are required");
    }
    if (!WalletAddress) {
      // Display an error message or handle validation failure as needed
      error.WalletAddress = 'Wallet Address is required';
      // toast.error("All fields are required");
    }
    if (!RegisterFundSubscriber.ConfirmPassword) {
      // Display an error message or handle validation failure as needed
      error.ConfirmPassword = 'Confirm Password is required';
      // toast.error("All fields are required");
    } else if (
      RegisterFundSubscriber.Password !== RegisterFundSubscriber.ConfirmPassword
    ) {
      error.ConfirmPassword =
        'Password and Confirm Password do not match. Please ensure that both fields contain the same information for confirmation.';
    }

    console.log('🚀 ~ onSubmit ~ error:', error);

    if (Object.keys(error).length > 0) {
      setValidation(error);
      return;
    }
    try {
      const data = await Api.Api.post('/fundSubscriber/createuser', {
        firstName: RegisterFundSubscriber.firstName,
        lastName: RegisterFundSubscriber.Lastname,
        email: RegisterFundSubscriber.email,
        walletAddress: WalletAddress,
        password: RegisterFundSubscriber.Password,
      });
      console.log(
        '🚀 ~ file: registerDataConsumer.js:67 ~ onSubmit ~ data:',
        data.data.message
      );
      if (data.data.success == true) {
        localStorage.setItem('otpemail', RegisterFundSubscriber.email);
        localStorage.setItem('otprole', 'Fund Subscriber'); // Store the role for OTP verification
        toast.success(data.data.message);
        Navigater('/auth/varifyOTP');
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error(error.message);
      }
    }
  };
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        marginTop: '10%',
        width: '100%',
        backgroundColor: '#F3F4F8',
      }}
    >
      <components.Loader.Back_Drop state={loaderState} />

      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          width: '50%',
        }}
      >
        <span className='Loginheading'>Register Fund Subscriber</span>
        <div className='LoginScreen'>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              height: 100,
              justifyContent: 'space-evenly',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: 10,
              }}
            >
              <span style={{ width: '90%', fontFamily: 'Manrope, sans-serif' }}>
                First Name
              </span>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: 10,
              }}
            >
              <TextField
                name='firstName'
                helperText={Validation.firstName}
                error={Validation.firstName}
                value={RegisterFundSubscriber.firstName}
                onChange={(e) => {
                  handleChange(e);
                }}
                style={{ width: '90%' }}
                id='outlined-basic'
                label='Enter your First Name'
                variant='outlined'
              />
              {/* <input placeholder='Enter Your Provider Title' type='text' /> */}
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              height: 100,
              justifyContent: 'space-evenly',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: 10,
              }}
            >
              <span style={{ width: '90%', fontFamily: 'Manrope, sans-serif' }}>
                Last Name
              </span>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: 10,
              }}
            >
              <TextField
                helperText={Validation.Lastname}
                error={Validation.Lastname}
                value={RegisterFundSubscriber.Lastname}
                onChange={(e) => {
                  handleChange(e);
                }}
                style={{ width: '90%' }}
                name='Lastname'
                id='outlined-basic'
                label='Enter Your Last Name'
                variant='outlined'
              />
              {/* <input placeholder='Enter Your Provider Title' type='text' /> */}
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              height: 100,
              justifyContent: 'space-evenly',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: 10,
              }}
            >
              <span style={{ width: '90%', fontFamily: 'Manrope, sans-serif' }}>
                Email Address
              </span>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: 10,
              }}
            >
              <TextField
                helperText={Validation.email}
                error={Validation.email}
                value={RegisterFundSubscriber.email}
                name='email'
                onChange={(e) => {
                  handleChange(e);
                }}
                style={{ width: '90%' }}
                id='outlined-basic'
                label='Enter Your Email Address'
                variant='outlined'
              />
              {/* <input placeholder='Enter Your Provider Title' type='text' /> */}
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              height: 100,
              justifyContent: 'space-evenly',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: 10,
              }}
            >
              <span style={{ width: '90%', fontFamily: 'Manrope, sans-serif' }}>
                Password
              </span>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: 10,
              }}
            >
              <TextField
                type={showPassword ? 'text' : 'password'}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position='end'>
                      <IconButton
                        edge='end'
                        onClick={() => setShowPassword((prev) => !prev)}
                        aria-label='toggle password visibility'
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                inputProps={{ autoComplete: 'new-password' }}
                helperText={Validation.Password}
                error={Validation.Password}
                value={RegisterFundSubscriber.Password}
                name='Password'
                onChange={(e) => {
                  handleChange(e);
                }}
                style={{ width: '90%' }}
                id='outlined-basic'
                label='Enter Your Password'
                variant='outlined'
              />
              {/* <input placeholder='Enter Your Provider Title' type='text' /> */}
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              height: 100,
              justifyContent: 'space-evenly',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: 10,
              }}
            >
              <span style={{ width: '90%', fontFamily: 'Manrope, sans-serif' }}>
                Confirm Password
              </span>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: 10,
              }}
            >
              <TextField
                type={showConfirmPassword ? 'text' : 'password'}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position='end'>
                      <IconButton
                        edge='end'
                        onClick={() => setshowConfirmPassword((prev) => !prev)}
                        aria-label='toggle password visibility'
                      >
                        {showConfirmPassword ? (
                          <Visibility />
                        ) : (
                          <VisibilityOff />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                helperText={Validation.ConfirmPassword}
                error={Validation.ConfirmPassword}
                name='ConfirmPassword'
                value={RegisterFundSubscriber.ConfirmPassword}
                onChange={(e) => {
                  handleChange(e);
                }}
                style={{ width: '90%' }}
                id='outlined-basic'
                label='Enter Your Confirm Password'
                variant='outlined'
              />
              {/* <input placeholder='Enter Your Provider Title' type='text' /> */}
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              height: 100,
              justifyContent: 'space-evenly',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: 10,
              }}
            >
              <span style={{ width: '90%', fontFamily: 'Manrope, sans-serif' }}>
                Connect Your Wallet
              </span>
            </div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: 10,
                width: '100%',
                flexDirection: 'column',
              }}
            >
              <Button onClick={connectWallet} variant='outlined'>
                {isconnected ? `Connected: ${WalletAddress?.slice(0, 6)}...${WalletAddress?.slice(-4)}` : 'Connect a wallet via Meta Mask'}
              </Button>
              <span style={{ color: Validation.WalletAddress ? 'red' : '' }}>
                {Validation.WalletAddress}
              </span>
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              width: '90%',
              alignSelf: 'center',
              justifyContent: 'flex-end',
              paddingBottom: 20,
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-evenly' }}>
              <Button
                variant='outlined'
                style={{ marginRight: 20 }}
                onClick={() => {
                  Navigater('/auth/Login');
                }}
              >
                {' '}
                Cancel
              </Button>
              <Button onClick={onSubmit} variant='contained'>
                Register
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterFundSubscriber;
